module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header'), _vm._v(" "), _c('main', [(_vm.post) ? _c('article', {
    staticClass: "wrap",
    class: _vm.$style.post
  }, [_c('header', {
    class: _vm.$style.header
  }, [_c('h1', {
    class: _vm.$style.title,
    domProps: {
      "innerHTML": _vm._s(_vm.post.title.rendered)
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.$style.body
  }, [_c('div', {
    class: _vm.$style.content,
    domProps: {
      "innerHTML": _vm._s(_vm.post.content.rendered)
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.meta
  }, [_vm._v(_vm._s(_vm.postedAt))])])]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8ff26ee0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Post.vue
// module id = 118
// module chunks = 2